module.exports = __webpack_public_path__ + "static/img/5.cac157f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/eng/5.png
// module id = lHa5
// module chunks = 0